// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-monaco-editor',
    editor: null,
    // #endregion
    // #region Properties
    props: {
        value: {
            type: String,
            required: false,
            default: '',
        },
        language: {
            type: String,
            required: false,
            default: 'plaintext',
        },
        isMinimapEnabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    // #endregion
    // #region Data
    data: () => ({
    /*editor: null as any,*/
    }),
    // #endregion
    // #region Watch
    watch: {
        value: {
            handler(newValue, oldValue) {
                this.editor && newValue !== this.getValue() && this.setValue(newValue);
            }
        }
    },
    // #endregion
    // #region Constructor
    async mounted() {
        //Vars
        var tGlobal = window;
        var tDom = this.$refs['editor'];
        if (!tGlobal.require) {
            tGlobal.require = {};
        }
        if (!tGlobal.require.paths) {
            tGlobal.require.paths = {};
        }
        //Set
        tGlobal.require.paths.vs = '/assets/lib/monaco/min/vs';
        //prepare           
        //tGlobal.MonacoEnvironment = {
        //    publicPath: '/assets/lib/monaco',
        //    paths: {
        //        editorWorkerService: '/assets/lib/monaco'
        //    },
        //    getWorkerUrl: function (moduleId: string, label: string) {
        //        //if (label === 'json') {
        //        //    return './json.worker.js';
        //        //}
        //        //if (label === 'css' || label === 'scss' || label === 'less') {
        //        //    return './css.worker.js';
        //        //}
        //        //if (label === 'html' || label === 'handlebars' || label === 'razor') {
        //        //    return './html.worker.js';
        //        //}
        //        //if (label === 'typescript' || label === 'javascript') {
        //        //    return './ts.worker.js';
        //        //}
        //        //return './editor.worker.js';
        //    }
        //};
        //Scripts
        await host.pageMeta.loadScript('/assets/lib/monaco/min/vs/loader.js');
        await host.pageMeta.loadScript('/assets/lib/monaco/min/vs/editor/editor.main.nls.js');
        await host.pageMeta.loadScript('/assets/lib/monaco/min/vs/editor/editor.main.js');
        //Styles
        await host.pageMeta.loadStyle('/assets/lib/monaco/min/vs/editor/editor.main.css');
        //New
        this.$options.editor = tGlobal.monaco.editor.create(tDom, {
            language: this.language,
            automaticLayout: true,
            scrollBeyondLastLine: false,
            minimap: {
                enabled: this.isMinimapEnabled
            },
        });
        //Events
        this.$options.editor.onDidChangeModelContent((event) => {
            this.emitChange(this.$options.editor.getValue(), event);
        });
    },
    beforeDestroy() {
        if (this.$options.editor) {
            this.$options.editor.dispose();
        }
    },
    // #endregion
    // #region Methods
    methods: {
        getEditor() {
            if (!this.$options.editor) {
                return null;
            }
            return this.$options.editor;
        },
        setValue(value) {
            let editor = this.getEditor();
            if (editor) {
                return editor.setValue(value);
            }
        },
        getValue() {
            let editor = this.getEditor();
            if (!editor) {
                return '';
            }
            return editor.getValue();
        },
        emitChange(value, event) {
            this.$emit('change', value, event);
            this.$emit('input', value);
        }
    }
    // #endregion
});
// #endregion
